// Translations
import { DESCRIPTION, TITLE } from '../translations/payment-processing.translations';

const PAYMENT_PROCESSING_LOADING_PROPS = {
  fetching: true,
  title: TITLE,
  description: DESCRIPTION,
};

export { PAYMENT_PROCESSING_LOADING_PROPS };
